<app-header class="mb-5 d-block"></app-header>
<router-outlet></router-outlet>